/*
 * Public API Surface of microapp-home
 */

export * from './lib/microapp-home.service';
export * from './lib/microapp-home.module';
export * from './pages/microapp-home.home.component';
export * from './pages/microapp-home.home.module';
